<template>
  <path
    d="M8 6.00018H16C17.1 6.00018 18 6.90018 18 8.00018V16.0002C18 17.1002 17.1 18.0002 16 18.0002H8C6.9 18.0002 6 17.1002 6 16.0002V8.00018C6 6.90018 6.9 6.00018 8 6.00018Z"
  />
</template>
